import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import TitleCase from "components/formatting/TitleCase";
import ISONumber from "components/formatting/ISONumber";
import ISOPercentage from "components/formatting/ISOPercentage";

interface ArcChartTooltipProps {
  arc: any;
}

export default function ArcChartTooltip(props: ArcChartTooltipProps): JSX.Element {
  const { i18n } = useTranslation();
  const { arc }: ArcChartTooltipProps = props;

  return (
    <Box>
      <Typography sx={{mb: 1}} variant="h4">
        <Box
          sx={{
            width: 14,
            height: 14,
            backgroundColor: arc.fill,
            display:"inline-block",
            mr: 1,
            borderRadius: "3px"
          }} />
        <TitleCase text={arc.name}/>
      </Typography>

      <Typography>
        {i18n.t("record-count")}:
        <Box sx={{ display: "inline-block", ml: 1 }}>
          <ISONumber number={arc.value} sx={{ fontWeight: "bold" }}/>
        </Box>
      </Typography>

      <Typography>
        {i18n.t("percent")}:
        <Box sx={{ display: "inline-block", ml: 1 }}>
          <ISOPercentage value={arc.percent} sx={{ fontWeight: "bold" }} />
        </Box>
      </Typography>
    </Box>
  );
}